import React, { useEffect, useState } from "react";
import {
  Table,
  Form,
  Breadcrumb,
  Button,
  Spinner,
  Modal,
  FormGroup,
  Row,
  Col,
} from "react-bootstrap";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import axios from "axios";
import {
  faCheckCircle,
  faComments,
  faEdit,
  faPlus,
  faSave,
  faTimes,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import Switch from "react-switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  COLOR_APP,
  COLOR_APP_CANCEL,
  LINK_SALE_PAGE,
  S3_URL,
} from "../../constants";
import { useToasts } from "react-toast-notifications";
import { v4 as uuidv4 } from "uuid";
import { GET_ADVERTISINGS, GET_SETTINGS } from "../../graphql/setting/query";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CREATE_ADVERTISING,
  CREATE_SETTING,
  DELETE_ADVERTISING,
  UPDATE_ADVERTISING,
  UPDATE_SETTING,
} from "../../graphql/setting/mutation";
import { GET_PRESIGN_URL } from "../../graphql/presignUrl/query";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { GET_BANKS } from "../../graphql/bank/query";
import {
  CREATE_BANK,
  DELETE_BANK,
  UPDATE_BANK,
} from "../../graphql/bank/mutation";
import moment from "moment";
import { MdAdd } from "react-icons/md";
import { BsLink } from "react-icons/bs";
import copy from "clipboard-copy";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import { GET_SHOPS } from "../../graphql/shop/queryShop";
import LoadingSpinner from "../../components/LoadingSpinner";

function Advertising() {
  const { addToast } = useToasts();
  const { history } = useReactRouter();

  const [bankName, setBankName] = useState();
  const [bankAccount, setBankAccount] = useState();
  const [bankUser, setBankUser] = useState();
  const [file, setFile] = useState();
  const [imageLoading, setImageLoading] = useState(0);
  const [fileName, setFileName] = useState();
  const [isEdited, setIsEdited] = useState(false);
  const [seleteAverTisingId, setSeleteIdAverTisingId] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { height, width } = useWindowDimensions();

  const [adverName, setAdverName] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [adverNote, setAdverNote] = useState();
  const [adverTisingLists, setAdverTisingLists] = useState([]);

  const [validated, setValidated] = useState(false);

  const handleSubmitAverTising = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false);
    } else {
      setValidated(true);
      handleCreateAdvertising();
    }
  };

  const [
    getAdvertisings,
    { data: adverTisings, loading: loadingAdverTisings },
  ] = useLazyQuery(GET_ADVERTISINGS, {
    fetchPolicy: "cache-and-network",
  });

  const [getShopData, { data: shopData, loading: shopLoading }] = useLazyQuery(
    GET_SHOPS,
    {
      fetchPolicy: "cache-and-network",
    },
  );

  const [createSetting] = useMutation(CREATE_SETTING);
  const [updateSetting] = useMutation(UPDATE_SETTING);
  const [createBank, { loading: createLoading }] = useMutation(CREATE_BANK);
  const [deleteBank] = useMutation(DELETE_BANK);

  const [createAdvertising, { loading: advertisingLoading }] =
    useMutation(CREATE_ADVERTISING);
  const [stopStatusInAdver, { loading: stopAdvertisingLoading }] =
    useMutation(UPDATE_ADVERTISING);
  const [updateAdverTising, { loading: updateLoading }] =
    useMutation(UPDATE_ADVERTISING);
  const [deleteAdverTising, { loading: deleteLoading }] =
    useMutation(DELETE_ADVERTISING);

  const [getPresignUrl, { data: presignUrlData }] =
    useLazyQuery(GET_PRESIGN_URL);

  const shopId = localStorage.getItem("SHOP");

  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      onFileUpload(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  useEffect(() => {
    _getAdverTisingData();
    fetchShop();
  }, [shopId]);

  useEffect(() => {
    if (adverTisings) {
      setAdverTisingLists(adverTisings);
    }
  }, [adverTisings]);

  console.log("shopData======>", shopData);

  const fetchShop = async () => {
    try {
      await getShopData({
        variables: {
          // skip: page * rowsPerPage,
          // limit: rowsPerPage,
          orderBy: "createdAt_DESC",
          where: {
            id: shopId,
            isDeleted: false,
            isUseInflu: true,
          },
        },
      });
    } catch (error) {
      console.log({ error });
    }
  };

  const _getAdverTisingData = async () => {
    getAdvertisings({
      variables: {
        where: {
          shop: shopId,
          //   status: false,
        },
      },
    });
  };

  const _deleteAverTising = async () => {
    try {
      await deleteAdverTising({
        variables: {
          where: {
            id: seleteAverTisingId,
          },
        },
      });
      _getAdverTisingData();
      setShowDeleteModal(false);
    } catch (error) {
      console.log("error", error);
    }
  };

  const _updateAdvertising = async (id) => {
    try {
      if (updateLoading) return;
      await updateAdverTising({
        variables: {
          data: {
            name: adverName,
            startDate: startDate,
            endDate: endDate,
            image: fileName,
          },
          where: {
            id: id,
          },
        },
      });
      setIsEdited(false);
      _getAdverTisingData();
      _clearData();
    } catch (err) {
      console.log(err);
      if (err.message === "BAD_REQUEST")
        return addToast("ກະລຸນາໃສ່ຂໍ້ມູນໃຫ້ຄົບກ່ອນ!", {
          appearance: "warning",
          autoDismiss: true,
        });
    }
  };

  const handleCreateAdvertising = async () => {
    if (advertisingLoading) return;

    const SHOP_ID = await localStorage.getItem("SHOP");

    const _createAdverTising = await createAdvertising({
      variables: {
        data: {
          name: adverName,
          image: fileName,
          note: adverNote,
          shop: SHOP_ID,
          startDate: startDate,
          endDate: endDate,
          status: false,
        },
      },
    });
    if (_createAdverTising) {
      addToast("ເພິ່ມເແບນເນີສຳເລັດແລ້ວ", {
        appearance: "success",
        autoDismiss: true,
      });
      _getAdverTisingData();
      setShowAddModal(false);
      _clearData();
    }
  };

  const ImageThumb = ({ image, height, width }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          objectFit: "contain",
          width: "100%",
          height: "100%",
          maxHeight: "400px",
        }}
      />
    );
  };

  const handleUpload = async (event) => {
    setImageLoading(0);

    try {
      setFile(event.target.files[0]);
      var ext = event.target.files[0].name.split(".").pop();
      let filename = uuidv4() + "." + ext;
      await getPresignUrl({
        variables: {
          name: filename,
        },
      });
      setFileName(filename);
    } catch (error) {
      console.log(error);
    }
  };

  const onFileUpload = async (url) => {
    try {
      if (file && url) {
        const uploadfile = await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
        // console.log("uploadfile: ", uploadfile);
      }
    } catch (error) {
      console.log("ERROR: ", error);
    }
  };

  const _clearData = () => {
    setAdverName("");
    setAdverNote("");
    setStartDate("");
    setEndDate("");
    setIsEdited(false);
    setFileName();
    setFile();
  };

  //   function ປີດການສະແດງຂອງຮູບໂຄສະນາ
  const onStopHook = async (id) => {
    try {
      if (stopAdvertisingLoading) return;
      const resultStop = await stopStatusInAdver({
        variables: {
          data: {
            status: true,
          },
          where: {
            id: id,
          },
        },
      });
      if (resultStop) {
        addToast("ປີດການໃຊ້ງານແລ້ວ", {
          appearance: "success",
          autoDismiss: true,
        });
        _getAdverTisingData();
      }
    } catch (err) {
      console.log(err);
      if (err.message === "BAD_REQUEST")
        return addToast("ກະລຸນາໃສ່ຂໍ້ມູນໃຫ້ຄົບກ່ອນ!", {
          appearance: "warning",
          autoDismiss: true,
        });
    }
  };
  //   function ເປີດການສະແດງຂອງຮູບໂຄສະນາ
  const onOnAirHook = async (id) => {
    try {
      if (stopAdvertisingLoading) return;
      const resultOnAir = await stopStatusInAdver({
        variables: {
          data: {
            status: false,
          },
          where: {
            id: id,
          },
        },
      });
      if (resultOnAir) {
        addToast("ເປີດການໃຊ້ງານແລ້ວ", {
          appearance: "success",
          autoDismiss: true,
        });
        _getAdverTisingData();
      }
    } catch (err) {
      console.log(err);
      if (err.message === "BAD_REQUEST")
        return addToast("ກະລຸນາໃສ່ຂໍ້ມູນໃຫ້ຄົບກ່ອນ!", {
          appearance: "warning",
          autoDismiss: true,
        });
    }
  };

  // copy link
  const handleCopyLink = async () => {
    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

    const url = LINK_SALE_PAGE + `/shop/${shopId}`;

    try {
      await copy(url);
      addToast("ກ໋ອບປີ່ລິ້ງສຳເລັດແລ້ວ!", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.error("Copy failed: ", error);
    }
  };

  const closeModalConfirm = () => {
    setShowDeleteModal(false);
  };

  return (
    <div>
      <ModalConfirmComponent
        showConfirmModal={showDeleteModal}
        handleCancel={closeModalConfirm}
        loadingConfirm={deleteLoading}
        handleConfirm={_deleteAverTising}
        text="ທ່ານຕ້ອງການລົບແບນເນີແທ້ບໍ?"
      />

      <Modal
        show={showAddModal}
        onHide={() => {
          setShowAddModal(false);
          _clearData();
        }}
        keyboard={false}
        size="lg"
      >
        <Modal.Header
          style={{
            background: COLOR_APP,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: 50,
            color: "#fff",
          }}
        >
          <h5>ເພິ່ມເແບນເນີໂຄສະນາ</h5>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            width: "100%",
          }}
        >
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmitAverTising}
          >
            <Form.Group controlId="validationCustom01">
              <Form.Label>ຊື່ເແບນເນີ</Form.Label>
              <Form.Control
                onChange={(e) => {
                  setAdverName(e?.target?.value);
                }}
                required
                className="mb-2"
                type="text"
                placeholder="ຊື່ແບນເນີ..."
                value={adverName || ""}
              />
              <Form.Control.Feedback type="invalid">
                <small style={{ color: "red" }}>ກະລຸນາປ້ອນຊື່ແບນເນີກ່ອນ!</small>
              </Form.Control.Feedback>
            </Form.Group>
            <Row>
              <Col>
                <Form.Group controlId="validationCustom02">
                  <Form.Label>ວັນທີສ້າງ</Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      setStartDate(e?.target?.value);
                    }}
                    required
                    className="mb-2"
                    type="date"
                    value={startDate || ""}
                  />
                  <Form.Control.Feedback type="invalid">
                    <small style={{ color: "red" }}>
                      ກະລຸນາປ້ອນວັນທີ່ສ້າງ!
                    </small>
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="validationCustom03">
                  <Form.Label>ວັນທີສິ້ນສຸດ</Form.Label>
                  <Form.Control
                    onChange={(e) => {
                      setEndDate(e?.target?.value);
                    }}
                    required
                    className="mb-2"
                    type="date"
                    placeholder="ເລກບັນຊີ..."
                    value={endDate || ""}
                  />
                  <Form.Control.Feedback type="invalid">
                    <small style={{ color: "red" }}>
                      ກະລຸນາປ້ອນວັນທີ່ສິ້ນສຸດ!
                    </small>
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <FormGroup>
              <Form.Label>ລາຍລະອຽດ</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                onChange={(e) => {
                  setAdverNote(e?.target?.value);
                }}
                className="mb-2"
                type="text"
                placeholder="ລາຍລະອຽດ..."
                value={adverNote || ""}
              />
            </FormGroup>
            <div className="col-sm-12 center" style={{ textAlign: "center" }}>
              <input
                type="file"
                id="file-upload"
                onChange={(e) => {
                  handleUpload(e);
                }}
                hidden
              />
              <label htmlFor="file-upload" className="w-100">
                <div
                  style={{
                    background: "#E4E4E4E4",
                    width: "100%",
                    height: "150px",
                    borderRadius: 8,
                    cursor: "pointer",
                    display: "flex",
                  }}
                >
                  {file ? (
                    <ImageThumb image={file} height={150} widht="100%" />
                  ) : (
                    <div
                      style={{
                        height: "100px",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#fff",
                        fontSize: 100,
                        fontWeight: "bold",
                      }}
                    >
                      +
                    </div>
                  )}
                </div>
              </label>
              <div>
                <span>
                  ເລືອກຮູບເແບນເນີ ທີ່ມີຂະໜາດກ້ວາງປະມານ (1024px X 340px)
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2em",
              }}
            >
              <Button
                type="submit"
                // onClick={handleSubmitAverTising}
                style={{
                  width: "180px",
                  marginRight: 10,
                  background: COLOR_APP,
                  fontWeight: "bold",
                }}
              >
                {advertisingLoading ? (
                  <Spinner size="sm" animation="border" />
                ) : (
                  "ບັນທຶກ"
                )}
              </Button>
              <Button
                onClick={() => {
                  setShowAddModal(false);
                  _clearData();
                }}
                style={{
                  width: "180px",
                  border: "1px solid " + COLOR_APP_CANCEL,
                  background: "transparent",
                  color: COLOR_APP_CANCEL,
                }}
              >
                ຍົກເລີກ
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div>
        <div style={{ height: 20 }} />
        <Breadcrumb>
          <Breadcrumb.Item onClick={() => history.replace("/settings")}>
            ຕັ້ງຄ່າ
          </Breadcrumb.Item>
          <Breadcrumb.Item active>ຕັ້ງຄ່າເຊວເພຈ</Breadcrumb.Item>
        </Breadcrumb>
        <div style={{ height: 10 }} />
        <div
          style={{
            display: "flex",
            flexDirection: width > 700 ? "row" : "column",
            justifyContent: "space-between",
            padding: "0 1em",
          }}
        >
          <h3
            style={{
              color: "#616161",
              fontSize: width > 700 ? "1.75em" : "1.5em",
            }}
          >
            ຮູບໂຄສະນາສິນຄ້າໃນ ເຊວເພຈ [
            {loadingAdverTisings ? "..." : adverTisings?.advertisements?.total}]
          </h3>

          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              gap: "1em",
            }}
          >
            {width > 700 && (
              <>
                <Button
                  style={{
                    background: "#F7F7F7",
                    color: "#422F90",
                    border: "1px solid #422F90 ",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: width > 700 ? "row" : "column",
                  }}
                  onClick={handleCopyLink}
                >
                  <BsLink style={{ fontSize: 26 }} />{" "}
                  <span> ສຳເນົາລິ້ງ {width > 700 && "ເຊວເພຈ"}</span>
                </Button>
                <Button
                  onClick={() => {
                    _clearData();
                    setShowAddModal(true);
                  }}
                  style={{ background: COLOR_APP }}
                >
                  <MdAdd style={{ fontSize: 23 }} />
                  &nbsp;ເພີ່ມເແບນເນີ
                </Button>
              </>
            )}
          </div>
        </div>
        {width < 700 && (
          <div className="p-2">
            <Button
              style={{
                background: "#F7F7F7",
                color: "#422F90",
                border: "1px solid #422F90 ",
                width: "100%",
              }}
              onClick={handleCopyLink}
            >
              <BsLink style={{ fontSize: 26 }} />{" "}
              <span> ສຳເນົາລິ້ງ ເຊວເພຈ</span>
            </Button>
          </div>
        )}
        <div style={{ height: 20 }} />
        <div className="row">
          <div style={{ padding: 20 }}>
            <Table responsive>
              <thead>
                <tr style={{ whiteSpace: "nowrap" }}>
                  <th style={{ borderBottom: "none" }}>ລ/ດ</th>
                  <th style={{ borderBottom: "none" }}>ຮູບເແບນເນີ</th>
                  <th style={{ borderBottom: "none" }}>ຊື່ເແບນເນີ</th>
                  <th style={{ borderBottom: "none" }}>ວັນທີສ້າງ</th>
                  <th style={{ borderBottom: "none" }}>ວັນທີສິ້ນສຸດ</th>
                  <th style={{ borderBottom: "none" }}>ການໃຊ້ງານ</th>
                  <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                </tr>
              </thead>
              {loadingAdverTisings ? (
                <tbody>
                  <tr>
                    <td colSpan={7}>
                      <div
                        style={{
                          width: "100%",
                          height: "30vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <LoadingSpinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {adverTisings?.advertisements?.data?.length > 0 &&
                    adverTisings?.advertisements?.data?.map(
                      (dataAver, index) => (
                        <tr key={dataAver?.id} style={{ whiteSpace: "nowrap" }}>
                          <td>{index + 1}</td>
                          <td>
                            {isEdited && seleteAverTisingId === dataAver?.id ? (
                              <div
                                className="col-sm-12 center"
                                style={{ textAlign: "center" }}
                              >
                                <input
                                  type="file"
                                  id="file-upload"
                                  onChange={handleUpload}
                                  hidden
                                />
                                <label htmlFor="file-upload">
                                  <div
                                    style={{
                                      background: "#E4E4E4E4",
                                      height: 60,
                                      width: 100,
                                      borderRadius: 8,
                                      cursor: "pointer",
                                      display: "flex",
                                    }}
                                  >
                                    {file ? (
                                      <ImageThumb image={file} />
                                    ) : (
                                      <div
                                        style={{
                                          height: "auto",
                                          width: "auto",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {!dataAver?.image ? (
                                          <div
                                            style={{
                                              color: "#616161",
                                              fontSize: 20,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            +
                                          </div>
                                        ) : (
                                          <img
                                            src={S3_URL + dataAver?.image}
                                            style={{
                                              borderRadius: 8,
                                              height: 60,
                                              width: 100,
                                            }}
                                            alt="imageAver"
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </label>
                              </div>
                            ) : (
                              <div
                                style={{
                                  background: "#eee",
                                  height: 60,
                                  width: 100,
                                  borderRadius: 8,
                                  display: "flex",
                                }}
                              >
                                {isEdited &&
                                seleteAverTisingId === dataAver?.id &&
                                file ? (
                                  <ImageThumb image={file} />
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      height: "auto",
                                      width: "auto",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    {!dataAver?.image ? (
                                      <p></p>
                                    ) : (
                                      <img
                                        src={S3_URL + dataAver?.image}
                                        style={{
                                          borderRadius: 8,
                                          height: 60,
                                          width: 100,
                                        }}
                                        alt="imageAver"
                                      />
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </td>
                          {isEdited && seleteAverTisingId === dataAver?.id ? (
                            <td>
                              <Form.Control
                                onChange={(e) => {
                                  let _adverName = adverName;
                                  _adverName = e?.target?.value;
                                  setAdverName(_adverName);
                                }}
                                type="text"
                                name="name"
                                placeholder="ຊື່ເແບນເນີ..."
                                value={adverName}
                              />
                            </td>
                          ) : (
                            <td>{dataAver?.name}</td>
                          )}
                          {isEdited && seleteAverTisingId === dataAver?.id ? (
                            <td>
                              <Form.Control
                                onChange={(e) => {
                                  let _bankAccount = bankAccount;
                                  _bankAccount = e.target.value;
                                  setStartDate(_bankAccount);
                                }}
                                type="date"
                                value={startDate || ""}
                              />
                            </td>
                          ) : (
                            <td>
                              {moment(dataAver?.startDate).format(
                                "DD/MM/YYYY  HH:mm",
                              )}
                            </td>
                          )}
                          {isEdited && seleteAverTisingId === dataAver?.id ? (
                            <td>
                              <Form.Control
                                onChange={(e) => {
                                  let _bankUser = bankUser;
                                  _bankUser = e.target.value;
                                  setEndDate(_bankUser);
                                }}
                                type="date"
                                value={endDate || ""}
                              />
                            </td>
                          ) : (
                            <td>
                              {moment(dataAver?.endDate).format(
                                "DD/MM/YYYY  HH:mm",
                              )}
                            </td>
                          )}

                          <td>
                            {dataAver?.status === false && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                <Switch
                                  onChange={() => onStopHook(dataAver?.id)}
                                  checked={true}
                                  onColor="#bfbdc7"
                                  onHandleColor="#422f90"
                                  handleDiameter={20}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                  height={20}
                                  width={38}
                                  className="react-switch"
                                  id="material-switch"
                                />
                                <span>ເປີດ</span>
                              </div>
                            )}
                            {dataAver?.status === true && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                <Switch
                                  onChange={() => onOnAirHook(dataAver?.id)}
                                  checked={false}
                                  onColor="#bfbdc7"
                                  onHandleColor="#422f90"
                                  handleDiameter={20}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                  height={20}
                                  width={38}
                                  className="react-switch"
                                  id="material-switch"
                                />
                                <span>ປີດ</span>
                              </div>
                            )}
                          </td>

                          {isEdited && seleteAverTisingId === dataAver?.id ? (
                            <td style={{ whiteSpace: "nowrap" }}>
                              {" "}
                              <button
                                className="btn hoverme col-6 align-self-start"
                                onClick={() => _updateAdvertising(dataAver?.id)}
                                style={{
                                  borderColor: COLOR_APP,
                                  color: COLOR_APP,
                                }}
                              >
                                {updateLoading ? (
                                  <Spinner size="sm" animation="border" />
                                ) : (
                                  <div>
                                    <FontAwesomeIcon
                                      icon={faSave}
                                      style={{
                                        borderColor: COLOR_APP,
                                        color: COLOR_APP,
                                      }}
                                    />{" "}
                                    ບັນທຶກ
                                  </div>
                                )}
                              </button>
                              <button
                                className="btn hoverme col-6 ml-2"
                                style={{
                                  borderColor: COLOR_APP_CANCEL,
                                  color: COLOR_APP_CANCEL,
                                }}
                                onClick={() => {
                                  setIsEdited(false);
                                  setSeleteIdAverTisingId("");
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  style={{ color: COLOR_APP_CANCEL }}
                                />
                                {" \t"}
                                ຍົກເລີກ
                              </button>
                            </td>
                          ) : (
                            <td style={{ whiteSpace: "nowrap" }}>
                              <button
                                className="btn hoverme"
                                onClick={() => {
                                  setIsEdited(true);
                                  setSeleteIdAverTisingId(dataAver?.id);
                                  setBankAccount(dataAver?.bankAccount || "");
                                  setBankName(dataAver?.bankName || "");
                                  setBankUser(dataAver?.bankUser || "");
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  style={{ color: COLOR_APP }}
                                />
                              </button>
                              <button
                                className="btn hoverme"
                                onClick={() => {
                                  setSeleteIdAverTisingId(dataAver?.id);
                                  setShowDeleteModal(true);
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  style={{ color: "red" }}
                                />
                              </button>
                            </td>
                          )}
                        </tr>
                      ),
                    )}
                </tbody>
              )}
            </Table>
          </div>
        </div>
      </div>
      {width <= 700 && (
        <div
          style={{ marginLeft: 10, marginTop: 10 }}
          className="floating-container"
        >
          <div
            onClick={() => {
              _clearData();
              setShowAddModal(true);
            }}
            style={{ marginLeft: 10, marginTop: 10 }}
            className="floating-button"
          >
            <FontAwesomeIcon icon={faPlus} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Advertising;
